import { render, staticRenderFns } from "./pax_form.vue?vue&type=template&id=730f2412&scoped=true&"
import script from "./pax_form.vue?vue&type=script&lang=js&"
export * from "./pax_form.vue?vue&type=script&lang=js&"
import style0 from "./pax_form.vue?vue&type=style&index=0&id=730f2412&scoped=true&lang=css&"
import style1 from "./pax_form.vue?vue&type=style&index=1&id=730f2412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730f2412",
  null
  
)

export default component.exports